import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NavService } from './nav.service';
import { NavbarComponent } from './navbar/navbar.component';
import { SideNavContainerComponent } from './side-nav-container/side-nav-container.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { ThemeToggleComponent } from './theme-toggle.component';
import { UiToggleComponent } from './ui-toggle.component';
import { MenuService } from './menu.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NavbarComponent,
    SideNavComponent,
    SideNavContainerComponent,
    ThemeToggleComponent,
    UiToggleComponent,
  ],
  exports: [NavbarComponent, SideNavComponent, SideNavContainerComponent, ThemeToggleComponent, UiToggleComponent],
  providers: [NavService, MenuService],
})
export class NavModule { }
